// extracted by mini-css-extract-plugin
export default {"mainContainer":"ListOfUsers_mainContainer__gKLbw","actionBox":"ListOfUsers_actionBox__0sWqr","actionButtonsBox":"ListOfUsers_actionButtonsBox__eGqh5"};